/**
 * Juste apres l'activation (design 4.1, etapes 4 et 5) : le magasin reconnu
 * en gros, la synchro du catalogue avec sa barre de progression, puis
 * « Poste prêt » et la liste « Employés à connecter une fois en ligne ».
 */
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CatalogStatus from './CatalogStatus';
import EmployeeChecklist from './EmployeeChecklist';
import { palette } from './theme';

export default function SetupScreen({ terminal, sync, onSync, onContinue }) {
    return (
        <Box
            data-testid="ecran-poste-pret"
            sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, p: 4, textAlign: 'center', overflowY: 'auto' }}
        >
            <Typography component="h1" data-testid="poste-magasin" sx={{ fontSize: 48, fontWeight: 800, color: palette.text }}>
                {terminal.store_name || `Magasin ${terminal.store_id}`}
            </Typography>
            <Typography data-testid="poste-nom" sx={{ fontSize: 28, color: palette.textSecondary }}>
                {terminal.name}
            </Typography>
            <Box sx={{ textAlign: 'left', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
                <CatalogStatus
                    catalogMeta={sync.catalogMeta}
                    catalogSync={sync.catalogSync}
                    syncing={sync.syncing}
                    progress={sync.progress}
                    onSync={onSync}
                />
            </Box>
            {/* Apres le premier essai de synchro (reussi ou non : le poste est active). */}
            {!sync.syncing && sync.catalogSync && (
                <>
                    <Box
                        sx={{
                            display: 'flex', alignItems: 'center', gap: 1.5, px: 3, py: 1.5, borderRadius: 2,
                            bgcolor: palette.successTint, color: palette.successOnTint,
                        }}
                    >
                        <CheckCircleIcon sx={{ fontSize: 40 }} aria-hidden="true" />
                        <Typography sx={{ fontSize: 32, fontWeight: 800 }}>Poste prêt</Typography>
                    </Box>
                    <Box sx={{ textAlign: 'left', width: '100%', display: 'flex', justifyContent: 'center' }}>
                        <EmployeeChecklist employees={sync.employees} />
                    </Box>
                    <Button variant="contained" size="large" onClick={onContinue} sx={{ minHeight: 88, px: 8 }}>
                        Continuer
                    </Button>
                </>
            )}
        </Box>
    );
}
